<template>
  <div class="z-0">
    <!-- overlay signup -->
    <overlay name="signup" height="auto" width="90%" :max-width="425" :adaptive="true" :scrollable="true" :resizeable="true" :reset="true">
      <div class="db absolute z-999 z-2 right-0 mt2 mh2 pointer grow menu-icon-close" alt="close modal" @click="$modal.hide('signup')">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>      
      <div class="db relative z-998 center mw8 w-100 vh-85-xs h-modal-ns pa3">
        <section class="db relative center w-100 h-100">
          <div class="flex relative center h-100 flex-column items-center content-center justify-center">
            <signup></signup>
            <div class="flex center flex-row items-center justify-between w-100 mw5 mw6-ns mt3 mw21rem">
              <social-icons></social-icons>
            </div>
          </div>
        </section>
      </div>
      <div class="db absolute bottom-0 w-100 nb2 nb3-ns w-105 mh--05">
        <simple-svg
          :filepath="'/assets/images/svg/gdz18-grandoozy-logo-outline.svg'"
          :id="'gdz-logo-footer-green'"
        ></simple-svg>
      </div>
    </overlay>
    <!-- overlay video -->
    <overlay name="video" ref="youtube" @before-open="beforeOpen" :ytId="ytId" v-bind:iframeSrc="iframeSrc" height="auto" width="100%" :class="'overlay-video'" :max-width="992" :adaptive="true" :scrollable="true" :resizeable="true" :reset="true">
      <div class="db relative z-998 center mw8 w-100 vh-85-xs vh-75-ns ph2" @click="$modal.hide('video')">
        <section class="db relative z-998 center w-100 h-100">
          <div class="flex relative z-998 center h-100 flex-column items-center content-center justify-center">
            <div class="db relative z-998 center w-100 h-auto">
              <div class="db absolute z-999 z-2 right-0 top-0 nr1 nt4 nt3 pointer grow menu-icon-close" alt="close modal" @click="$modal.hide('video')">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>    
              <div class="video-wrapper">
                <div class="absolute absolute--fill">
                  <div class="modal-vid-container modal-element video-wrapper">
                    <div class="modal-vid-embed-wrapper modal-element absolute--fill">
                      <iframe id="existing-iframe-example"
                              width="640" height="360"
                              src="https://www.youtube.com/embed/hwR_1EP18eo?enablejsapi=1&autoplay=1"
                              frameborder="0"
                              style="border: solid 1px #F2FFE5"
                      ></iframe>
                      <!--
                      <iframe v-bind:src="iframeSrc" frameborder="0" allowfullscreen id="video" class="modal-element embed-responsive-item" title="Grandoozy announcement video"></iframe>
                      -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="db dn-ns absolute bottom-0 w-100 nb1 nb2-ns">
      </div>
    </overlay>
    <app-header v-show="isIntroPage == false"></app-header>
      <transition name="appfade">
        <router-view v-show="appIsLoaded"></router-view>
      </transition>
    <app-footer v-show="isIntroPage == false"></app-footer>
  </div>
</template>

<script>
import AppHeader from './app-header.vue';
import AppFooter from './app-footer.vue';
import Signup from './signup.vue';
import { bus } from '../assets/js/src/main';
import Marked from 'marked';
export default {
  //template: '#app-template',
  components: {
    'app-header': AppHeader,
    'app-footer': AppFooter,
    'signup': Signup
  },
  props: ['appIsLoaded'],
  data () {
    return {
      navIsOpen: false,
      overlayIsOpen: false,
      ytId: '',
      iframeSrc: '',
      isIntroPage: false
    }
  },
  computed: {
    player () {
      return this.$refs.youtube.player
    }
  },
  methods: {
    openNav() {
      this.navIsOpen = true;
    },
    closeNav() {
      this.navIsOpen = false;
    },
    openOverlay(modalId) {
      this.overlayIsOpen = true;
    },
    closeOverlay() {
      this.overlayIsOpen = false;
    },
    beforeOpen (event) {
      //console.log('beforeOpen', event.params.ytId);
      //this.ytId = event.params.ytId;
      //this.iframeSrc = '//www.youtube.com/embed/' + this.ytId + '?enablejsapi=1&html5=1&autoplay=1';
      //this.iframeSrc = '//www.youtube.com/embed/' + this.ytId + '?enablejsapi=1&html5=1';
    },
    appIsLoadedBg () {
      setTimeout(
        function(){ 
          return false
        }, 1000);
    }
  },
  created () {
    var tag = document.createElement('script');
    //tag.id = 'iframe-demo';
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    var player;
    function onYouTubeIframeAPIReady() {
      player = new YT.Player('existing-iframe-example', {
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
          }
      });
    }
    bus.$on('openVidModal', (data) => {
      console.log('bus.openVidModal 1 - ');

      function onPlayerReady(event) {
        this.ytId = data;

          console.log('bus.openVidModal 2 - ');
          
          player.playVideo();
          console.log('bus.openVidModal 3 - ');

          //event.target.playVideo();

      }
      this.$modal.show('video', { ytId: this.ytId });
    });

    //
    bus.$on('isIntroPageBus', (data) => {
      this.isIntroPage = true;
    });
  },
  mounted () {
    this.$nextTick(() => {
      //console.log('app.vue - mounted - nextTick()');
      /****************************
      DOC READY
      ****************************/
      //doc ready
      $(function() {
        //
      })
    });
  },
  updated(){
    //console.log('app-header - updated', this.$route.path)
    if (this.$route.path === '/') {
      this.isIntroPage = true;
    }
    else {
      this.isIntroPage = false;
    }
  }
}
</script>